<template>
    <div v-if="settings.show">
        <b-modal v-model="gpsRequestPopup"
                 :content-class=" 'custom-modal ' + (settings.sectionClass ? settings.sectionClass : '')">
            <div v-if="settings.show">
                <div class="modal-icon">
                    <img src="../../assets/icons/gps_popup_icon.svg">
                </div>
                <h2 class="modal-title">{{translate('manageGPSLocation')}}</h2>
                <div class="modal-subtitle">{{translate('manageGPSAllowText')}}</div>
                <div class="modal__remember">*{{translate('manageGPSAllowSubtitle')}}</div>
            </div>
            <template v-slot:modal-footer>
                <div class="footer-ok__btn" @click="onOkClick">{{translate('OK')}}</div>
            </template>
        </b-modal>
    </div>
</template>

<script>
    import _ from "lodash";

    export default {
        name: "allowGpsRequestPopup",
        data() {
            return {
                gpsRequestPopup: _.isEmpty(this.settings),
            }
        },
        props: {
            settings: {
                type: [Object, null],
                default: () => {
                    return {}
                }
            },
        },
        watch: {
            settings(newValue) {
                this.gpsRequestPopup = !_.isEmpty(newValue)
            }
        },
        methods: {
            onOkClick () {
                this.gpsRequestPopup = false
                this.settings.onOkHandler()
            }
        }
    }
</script>

<style scoped>
    .modal-title {
        margin-top: 5px;
    }
    .modal-icon {
        margin-top: -35px;
    }
    .modal__remember {
        font-family: Nunito;
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 20px;
        color: #2F2F2F;
        opacity: 0.7;
        margin-top: 41px;
        text-align: left;
    }
    .footer-ok__btn {
        background: #3F405C;
        border-radius: 6px;
        width: 100%;
        padding: 12px;
        color: white;
    }
</style>